import { useEffect } from 'react';

/**
 * SEO helper: updates document title, meta description, canonical URL, and
 * Open Graph / Twitter tags per route. No external dependency required.
 *
 * Usage:
 *   <Seo title="Buy Property in Mumbai" description="..." path="/properties?city=Mumbai" />
 */
const SITE_NAME = 'Bharat Estate';
const SITE_BASE = 'https://bharat.estate';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_realty-complete/artifacts/qyc1eei7_Png%20Short%20Logo%20%2819%29.png';

const setMeta = (selector, attrName, attrValue, content) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attrName, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const Seo = ({ title, description, path, image, noIndex }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Buy, Sell & Rent Property Across India`;
    const desc = description || "India's premier real estate platform. Verified listings, smart calculators, market insights. Premium plans from ₹99/month.";
    const url = path ? `${SITE_BASE}${path}` : SITE_BASE;
    const img = image || DEFAULT_IMAGE;

    document.title = fullTitle;

    setMeta('meta[name="description"]', 'name', 'description', desc);
    setMeta('meta[name="robots"]', 'name', 'robots', noIndex ? 'noindex, nofollow' : 'index, follow');
    setLink('canonical', url);

    setMeta('meta[property="og:title"]', 'property', 'og:title', fullTitle);
    setMeta('meta[property="og:description"]', 'property', 'og:description', desc);
    setMeta('meta[property="og:url"]', 'property', 'og:url', url);
    setMeta('meta[property="og:image"]', 'property', 'og:image', img);
    setMeta('meta[property="og:type"]', 'property', 'og:type', 'website');
    setMeta('meta[property="og:site_name"]', 'property', 'og:site_name', SITE_NAME);

    setMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');
    setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', fullTitle);
    setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', desc);
    setMeta('meta[name="twitter:image"]', 'name', 'twitter:image', img);
  }, [title, description, path, image, noIndex]);

  return null;
};

export default Seo;
